const envDev = process.env.NODE_ENV === 'development' || false

export const config = {
  env: process.env.NODE_ENV || 'development',
  // API_URL: envDev ? 'http://localhost:3333/' : 'https://api-blog.fortkol.com.br:3333/',
  API_URL: envDev ? 'http://localhost:3333/' : 'https://blog-api.fortkol.com.br/',
  API_KEY: envDev ? '26d7837a9e8d77f43c19886115e5a9292ac96838' : '26d7837a9e8d77f43c19886115e5a9292ac96838',
  BLOG_URL: envDev ? 'http://localhost:3003/' : 'https://blog.fortkol.com.br/'
}
